import { render, staticRenderFns } from "./patientPortalChangePassword.vue?vue&type=template&id=23e73baf&"
import script from "./patientPortalChangePassword.vue?vue&type=script&lang=js&"
export * from "./patientPortalChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports